import React from "react";
import { themeGet } from "styled-system";
import Box from "../Box";
import { FormattedMessage } from "react-intl";

import styled from "styled-components";

const TextContainer = styled.div`
  margin: 0 0 1rem;
  padding: 2rem 2rem;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  border: 2px solid ${props => (props.selected ? "#4844a3" : "transparent")};
  color: 29264c;
  white-space: pre-wrap;
  font-size: 1rem;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

const SpamButton = styled.button`
  font-size: 1rem;
  outline: none !important;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  line-height: 2rem;
  border-radius: 2rem;
  background: ${props => (props.selected ? "#4844a3" : "white")};
  border: none;
  width: ${props => (props.disabled ? "80%" : "100%")};
  opacity: ${props => (props.disabled ? "0.5" : "1")};
  transition: all 0.2s ease;
  display: block;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.04);
  padding: 0.75rem 1rem;
  color: ${props => (props.selected ? "white" : "#4844a3")};
  max-width: 150px;
  padding: 0.75rem 1rem;
  @media screen and (min-width: 72em) {
    max-width: 200px;
  }
  :hover {
    cursor: pointer;
  }
`;

const SelectButton = styled.button`
  font-size: 1rem;
  outline: none !important;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  line-height: 2rem;
  border-radius: 2rem;
  background: ${props => (props.selected ? "#4844a3" : "white")};
  border: none;
  width: ${props => (props.disabled ? "80%" : "100%")};
  opacity: ${props => (props.disabled ? "0.5" : "1")};
  transition: all 0.2s ease;
  display: block;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.04);
  padding: 0.75rem 1rem;
  color: ${props => (props.selected ? "white" : "#4844a3")};
  max-width: 150px;
  padding: 0.75rem 1rem;
  @media screen and (min-width: 72em) {
    max-width: 200px;
  }
  :hover {
    cursor: pointer;
  }
`;

const PeerReviewContainer = styled(Box)``;

export default ({ option, onSelected, selected, onReportSpam }) => {
  return (
    <PeerReviewContainer mb={5} selected={selected}>
      <TextContainer selected={selected}>{option.data}</TextContainer>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <SpamButton onClick={onReportSpam}>
          <FormattedMessage id="peerreview.reportSpam" />
        </SpamButton>
        <SelectButton onClick={onSelected} selected={selected}>
          <FormattedMessage id="peerreview.select" />
        </SelectButton>
      </Box>
    </PeerReviewContainer>
  );
};
